module.exports = __webpack_public_path__ + "img/1484644903.8f5e8d7b.jpg";